import type { ReactNode } from 'react';
import { Typography } from 'antd';
import ChatInput, { ChatInputProps } from './ChatInput';
import styles from './Chat.module.scss';



export interface ChatWelcomeScreenProps extends Omit<ChatInputProps, 'variant'> {
  greeting?: string;
  title?: ReactNode;
  description?: string;
  details?: string;
  suggestions?: Array<{ icon?: string; text: string; question: string }>;
  userName?: string;
}

const ChatWelcomeScreen = ({
  greeting,
  title = (
    <>
      Welcome to <span className={styles.brandAccent}>Rubix</span>
    </>
  ),
  description = 'More consistency. More repeatability. Better delivery.',
  details = 'Rubix turns complex HCM/WFM work into standardized, validated building blocks—so teams move faster with confidence.',
  suggestions = [],
  userName,
  ...inputProps
}: ChatWelcomeScreenProps) => {
  const trimmedGreeting = greeting?.trim();
  const trimmedUserName = userName?.trim();
  const resolvedGreeting = trimmedGreeting || (trimmedUserName ? `Hi, ${trimmedUserName}` : 'Hi');
  const handleSuggestionClick = (text: string) => {
    inputProps.onChange(text);
  };

  return (
    <div className={styles.welcomeScreen}>
      <Typography.Text className={styles.welcomeGreeting}>
        {resolvedGreeting}
      </Typography.Text>
      <Typography.Title level={2} className={styles.welcomeTitle}>
        {title}
      </Typography.Title>
      <Typography.Paragraph className={styles.welcomeDescription}>
        {description}
      </Typography.Paragraph>
      <Typography.Paragraph className={styles.welcomeDetails}>
        {details}
      </Typography.Paragraph>
      <ul className={styles.welcomeSuggestions}>
        {suggestions.map((item) => (
          <li key={item.text} className={styles.welcomeSuggestionItem}>
            <button
              type="button"
              className={styles.welcomeSuggestionButton}
              onClick={() => handleSuggestionClick(item.question)}
            >
              {item.icon && (
                <span className={styles.welcomeSuggestionIcon} aria-hidden="true">
                  {item.icon}
                </span>
              )}
              <span>{item.text}</span>
            </button>
          </li>
        ))}
      </ul>
      <div className={styles.welcomeInputContainer}>
        <ChatInput {...inputProps} variant="welcome" />
      </div>
    </div>
  );
};

export default ChatWelcomeScreen;
